module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page case-study ubob",
    class: {
      init: _vm.isInit
    }
  }, [_c('div', {
    staticClass: "landing"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('router-link', {
    staticClass: "more",
    attrs: {
      "to": "/clients"
    }
  }, [_c('span', [_vm._v("More Case Studies →")])])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row center-xs contact-btn"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12 text-center"
  }, [_c('router-link', {
    staticClass: "next",
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', [_vm._v("Connect to Create")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-btn"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 477.175 477.175"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 477.175 477.175",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs content"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/ubob-text-1.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Vodafone (Maharashtra) wanted to launch their new service offering targeted towards the youth - Young professionals, college and school kids called ‘Vodafone U’. Our affair with Radio Mirchi continued and resulted in the fortunate and planned birth of Vodafone U - Battle of the Bands a.k.a UBOB - Maharashtra’s first and largest college band competition.")]), _vm._v(" "), _c('img', {
    staticClass: "text-img",
    attrs: {
      "src": require("../img/ubob-text-2.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Vodafone and Radio Mirchi are already massive power houses and have a large following amongst the youth. But, grabbing the attention of the young and energetic minds is always a challenge especially on digital mediums. We created social media accounts on Facebook / Instagram / Twitter We wanted to reach out to a maximum amount of our audience across various towns and succesfully did so! Here’s how it all unfurled.")]), _vm._v(" "), _c('div', {
    staticClass: "large-img"
  }, [_c('img', {
    attrs: {
      "src": require("../img/ubob-image-1.jpg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs last"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('p', [_vm._v("If you’re looking for fresh and impactful solutions,"), _c('br'), _vm._v("we’re your guys.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ddc1f36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UbobCaseStudy.vue
// module id = 156
// module chunks = 0